import $ from 'jquery'

export default {
    name: 'assure-chirurgie',
    components: {},
    props: {
        list_exclu_chirurgies: Array
    },
    data() {
        return {
            all_checked: false,
            one_is_checked: [],
			each_cat_is_checked: [],
            text_grey: []
        }
    },

    watch: {
        one_is_checked() {
            this.$store.commit('SET_EXCLU_CHIRURGIE', this.one_is_checked)
        }
    },

    computed: {
        liste_chirurgies() {
            return this.$store.getters["liste_chirurgies"];
        },
    },

    mounted() {
        this.listeChirurgies()
    },

    methods: {
        listeChirurgies() {
            this.$store.dispatch('getListeChirurgies').then(() => {
                if (this.liste_chirurgies.length > 0) {
                    this.setSelectedChirurgies()
                } 
            }).then(() => { this.$store.commit('SET_EXCLU_CHIRURGIE', this.one_is_checked); this.$emit('pret') }).catch(() => { this.$emit('erreur') })
        },

        setSelectedChirurgies() {
			this.one_is_checked = []
            this.text_grey = []

            this.list_exclu_chirurgies.forEach(exclusion => {
                this.liste_chirurgies.forEach(categorie_chirurgie => {
					categorie_chirurgie.kchirurgies.forEach((kchirurgie) => {
						if (exclusion.id == kchirurgie.id) {
							this.text_grey[kchirurgie.id] = 'text-grey'
							this.one_is_checked.push(kchirurgie.id)
						}
					}) 
                });
            });
		},

        toutSelectionner() {
            let is_checked = $('#chirurgie-tous').is(":checked")

            this.toggleAllChecked(is_checked)
        },

        toggleAllChecked(is_checked) {
            this.one_is_checked = []
            this.each_cat_is_checked = []
            
            this.liste_chirurgies.forEach((categorie_chirurgie) => {
                if (is_checked) {
                    this.each_cat_is_checked.push(categorie_chirurgie.chirurgie_id)
                }

                categorie_chirurgie.kchirurgies.forEach((kchirurgie) => {
                    this.text_grey[kchirurgie.id] = (is_checked)?'text-grey':''

                    if (is_checked) {
                        this.one_is_checked.push(kchirurgie.id)
                    }
                })
            });
            
            this.all_checked = is_checked
        },

        /**
		 * Sélectionner / Déselectionner une catégorie d'analyse
		 */
		touteCategorie(index) {
			let is_checked = $('#catchirurgie-tous'+index).is(":checked")
			this.toggleCategorieChecked(is_checked, index)
		},

		toggleCategorieChecked(is_checked, index) {
            this.liste_chirurgies.forEach((categorie_chirurgie) => {
                if (categorie_chirurgie.chirurgie_id == index) {
                    categorie_chirurgie.kchirurgies.forEach((kchirurgie) => {
                        this.text_grey[kchirurgie.id] = (is_checked)?'text-grey':''

                        if (is_checked) {
                            this.one_is_checked.push(kchirurgie.id)
                        } else {
                            let index_of = this.one_is_checked.indexOf(kchirurgie.id)
                            if (index_of > -1) {
                                this.one_is_checked.splice(index_of, 1)
                            }
                        }
                    })
                }
            });
            
            this.all_checked = is_checked
        },

        /**
		 * Sélectionner / Déselectionner une catégorie de médicament
		 */
		// touteCategorie(index) {
		// 	let is_checked = $('#categorie-tous'+index).is(":checked")

        //     this.toggleCategorieChecked(is_checked, index)
		// },

        // toggleCategorieChecked(is_checked, index) {
        //     console.log("II: ",index);
        //     this.liste_chirurgies.forEach((categorie_chirurgie) => {
        //         if (categorie_chirurgie.chirurgie_id == index) {
        //             console.log(">> ",categorie_chirurgie.kchirurgies);
        //             categorie_chirurgie.kchirurgies.forEach((kchirurgie) => {
        //                 this.text_grey[kchirurgie.k_id] = (is_checked)?'text-grey':''

        //                 if (is_checked) {
        //                     this.one_is_checked.push(kchirurgie.k_id)
        //                 } else {
        //                     let index_of = this.one_is_checked.indexOf(kchirurgie.k_id)
        //                     if (index_of > -1) {
        //                         this.one_is_checked.splice(index_of, 1)
        //                     }
        //                 }
        //             })
        //         }
        //     });
            
        //     this.all_checked = is_checked
        // },

        onExclu(index) {
            let is_checked = $('#kchirurgie'+index).is(":checked")

            let c = ''
            if (is_checked == true) {
                c = 'text-grey'
            }
            this.text_grey[index] = c
        },
    }
}
